import { Trans } from "@lingui/react";
import { useId } from "react";
import { Fragment } from "react/jsx-runtime";
import { useAppConfig } from "../../context/AppConfigProviderContext.tsx";
import { Paging } from "./Paging.tsx";

const Navigation = () => {
  const breadcrumbLabel = useId();
  const { breadcrumbs } = useAppConfig();
  if (breadcrumbs.length === 0) {
    return null;
  }

  return (
    <div className="flex pt-24">
      <div className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0">
        <nav aria-labelledby={breadcrumbLabel} className="mr-4">
          <h2 id={breadcrumbLabel} className="sr-only">
            <Trans id="itemPageLayout.breadcrumbs.title" message="You are here" />
          </h2>
          <div className="flex gap-x-8">
            {breadcrumbs.map((crumb, i) => {
              const className = i >= breadcrumbs.length - 2 ? "text-ellipsis overflow-hidden" : "hidden sm:block";
              return (
                <Fragment key={crumb.path}>
                  <a key={crumb.text} href={crumb.path} className={className}>
                    {crumb.text}
                  </a>
                  {i < breadcrumbs.length - 1 && (
                    <span className={`${className} select-none`} aria-hidden="true">
                      /
                    </span>
                  )}
                </Fragment>
              );
            })}
          </div>
        </nav>
      </div>
      <Paging />
    </div>
  );
};

export default Navigation;
